import { h } from '../../../../shared/utils/tsxToDom';
import styles from './index.module.css';

export const VisuallyHiddenText = ({ label }: { label: string }) => {
  return <span class={styles.VisuallyHiddenText}>{label}</span>;
};
